import { useEffect, useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { Title, usePermissions } from "react-admin";
import { useTenantName } from "@/hooks/useTenantName";
import { hasPermission } from "@/utils/permission-utils";
import LinkPhoneDialog from "@/layout/LinkPhoneDialog";
import ModulesDashboard from "@/containers/default-dashboard/ModulesDashboard";
import ItsOneViewDashboard from "@/containers/its-one-view/ItsOneViewDashboard";
import {
  readMainDashboardTab,
  writeMainDashboardTab,
  type MainDashboardTab,
} from "@/utils/main-dashboard-storage";

export default function MainDashboard() {
  const tenantName = useTenantName();
  const { permissions, isPending } = usePermissions();
  const canItsOneView = hasPermission(permissions, "itsOneView.view");

  const [tab, setTab] = useState<MainDashboardTab>(readMainDashboardTab);

  useEffect(() => {
    if (isPending) return;
    const stored = readMainDashboardTab();
    if (stored === "itsOneView" && canItsOneView) {
      setTab("itsOneView");
    } else {
      setTab("modules");
    }
  }, [isPending, canItsOneView]);

  useEffect(() => {
    writeMainDashboardTab(tab);
  }, [tab]);

  return (
    <>
      <Title title={tenantName || "Dashboard"} />
      <LinkPhoneDialog variant="banner" />
      {canItsOneView ? (
        <Tabs
          value={tab}
          onChange={(_e, next: MainDashboardTab) => setTab(next)}
          sx={{ mb: 2 }}
          aria-label="Main dashboard tabs"
        >
          <Tab value="modules" label="Modules" />
          <Tab value="itsOneView" label="ITS One View" />
        </Tabs>
      ) : null}
      <Box>
        {tab === "modules" || !canItsOneView ? <ModulesDashboard /> : <ItsOneViewDashboard />}
      </Box>
    </>
  );
}
